import React from 'react';
import { Alert } from 'react-bootstrap';
import '../styles/FormSectionStatus.css';

const FormSectionStatus = (props) => {
  function mapInvalidProps(){
    return props.invalidElements.map((element) => {
      return (
        <li key={element}>{element}</li>
      );
    });
  }

  function renderInvalidProps(){
    if(props.status === 'success' ||
       props.invalidElements.length === 0)
      return null;
    return (
      <ul className="list-inline element-list">
        {mapInvalidProps()}
      </ul>
    )
  }

  return(
    <Alert bsStyle={props.status} className='section-status'>
      {props.message}
      {renderInvalidProps()}
    </Alert>
  );
};

export default FormSectionStatus;